import axios from '../../axios'

/*
 * 文章数据接口
 */

// 小程序列表
export const sourceApi = (data) => {
    return axios({
        url: '/api/base/source',
        method: data.method || 'GET',
        data: data.data
    })
}

// 小程序省份列表
export const sourceProApi = (data) => {
    return axios({
        url: '/api/base/source/province',
        method: 'GET',
        data: data
    })
}

// 合作方标签列表
export const lableNameListApi = (data) => {
    return axios({
        url: '/api/data/wish/partners/type/list',
        method: 'GET',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/source.js